import { useEffect } from 'react'
import { SeverityLevel } from '@microsoft/applicationinsights-web'
import { trackException } from '@/helpers/telemetry/appInsights'

function parseError(error: unknown): { message: string; stack?: string } {
    if (error instanceof Error) {
        return { message: error.message, stack: error.stack }
    }
    return { message: String(error) }
}

export const useGlobalErrorReporting = () => {
    useEffect(() => {
        const handleError = (event: ErrorEvent) => {
            const { message, stack } = parseError(event.error ?? event.message)
            trackException(
                { message, stack },
                {
                    severityLevel: SeverityLevel.Error,
                    properties: { source: 'ControllerLog.Frontend', componentStack: stack },
                }
            )
        }

        const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
            event.preventDefault()
            const { message, stack } = parseError(event.reason)
            trackException(
                { message, stack },
                {
                    severityLevel: SeverityLevel.Error,
                    properties: { source: 'ControllerLog.Frontend', componentStack: stack },
                }
            )
        }

        window.addEventListener('error', handleError)
        window.addEventListener('unhandledrejection', handleUnhandledRejection)

        return () => {
            window.removeEventListener('error', handleError)
            window.removeEventListener('unhandledrejection', handleUnhandledRejection)
        }
    }, [])
}
